import SignInForm from 'components/modules/auth/SignInForm';
import AuthCardLayout from 'layouts/AuthCardLayout';

const SignIn = () => {
  return (
    <div className="position-relative">
      <AuthCardLayout className="">
        <SignInForm layout="card" />
      </AuthCardLayout>
    </div>
  );
};

export default SignIn;
